<div ngbDropdown  autoClose="outside" class="kt-header__topbar-item">
	<div ngbDropdownToggle class="kt-header__topbar-wrapper" ngbTooltip="Dev&nbsp;tools">
		<span class="kt-header__topbar-icon kt-pulse kt-pulse--brand kt-pulse--light kt-header__topbar-icon--danger">
			<span class="kt-svg-icon" [inlineSVG]="'./assets/media/icons/svg/Code/Compiling.svg'"></span>
			<span class="kt-pulse__ring"></span>
		</span>
	</div>
	<div ngbDropdownMenu class="dropdown-menu dropdown-menu-fit dropdown-menu-anim dropdown-menu-top-unround dropdown-menu-xl">
		<form>
			<!--begin: Head -->
			<div class="kt-head kt-head--skin-dark" [ngStyle]="{'background-image': 'url(./assets/media/bg/bg-2.jpg)'}">
				<h3 class="kt-head__title">
					Gakko Developer Tools
				</h3>
			</div>
			<!--end: Head -->
			<!--begin: Grid Nav -->
			<div class="kt-grid-nav kt-grid-nav--skin-light">
				<div class="kt-grid-nav__row">
					<a [routerLink]="AppPaths.App.InitialWizard.StringPath" class="kt-grid-nav__item">
						<span class="kt-grid-nav__icon" [inlineSVG]="'./assets/media/icons/svg/Communication/Group.svg'" (onSVGInserted)="onSVGInserted($event)"></span>
						<span class="kt-grid-nav__title">Initial wizard</span>
						<span class="kt-grid-nav__desc">Go to initial wizard page</span>
					</a>
				</div>
				<div class="kt-grid-nav__row">
					<a class="kt-grid-nav__item cursor-pointer" (click)="deleteCurrentUserData()">
						<span class="kt-grid-nav__icon" [inlineSVG]="'./assets/media/icons/svg/General/Trash.svg'" (onSVGInserted)="onSVGInserted($event)"></span>
						<span class="kt-grid-nav__title">Delete current user data</span>
						<span class="kt-grid-nav__desc">Delete data from Rek_Kandydat and connected tables. (It doesn't delete an account).</span>
					</a>
				</div>
				<!--end: Grid Nav -->
			</div>
		</form>
	</div>
</div>